import { render, staticRenderFns } from "./customDateKendoGridComponent.vue?vue&type=template&id=3990ae2e&"
import script from "./customDateKendoGridComponent.vue?vue&type=script&lang=js&"
export * from "./customDateKendoGridComponent.vue?vue&type=script&lang=js&"
import style0 from "./customDateKendoGridComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports